// extracted by mini-css-extract-plugin
export var attribution = "_bi-4";
export var authorName = "_bi-5";
export var quote = "_bi-3";
export var testimonial = "_bi-2";
export var trustedBy = "_bi-0";
export var trustedByLabel = "_bi-1";